<template>
  <div class="box">
    <!-- <van-nav-bar title="找回密码" left-arrow @click-left="Back"/> -->
    <van-form ref="formRef">
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        <div class="phons">
          请输入账号获取验证码
        </div>
      </van-notice-bar>
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        新密码长度8-20位 包含数字和字母
      </van-notice-bar>
      <van-field
        v-model="form.username"
        type="tel"
        colon
        name="username"
        placeholder="请输入账号"
        label="平台账号"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field name="userCode" colon v-model="form.userCode" type="digit" label="短信验证码" placeholder="请填写短信验证码" :rules="[{ required: true}]">
        <template #button>
          <van-button native-type="button" :disabled=formTime size="small" type="primary" @click="getVertify">
            <span v-show="!formTime">发送验证码</span>
            <van-count-down ref="countDown" v-show="formTime" time=60000 format="ss s后重新获取" @finish="changeDownCount" />
          </van-button>
        </template>
      </van-field>
      <!-- <div class="btnss">
        <van-button round block type="info" native-type="button" @click="onSubmits">下一步</van-button>
      </div> -->
    </van-form>
    <van-form ref="passwoarRef" validate-first validate-trigger="onBlur">
      <van-field name="NewPassword1" v-model="form.NewPassword1" colon type="password" label="新的密码" placeholder="新的密码" :rules="[{ validator: validators, message: '请填写格式正确的密码' }]" />
      <van-field name="NewPassword2" v-model="form.NewPassword2" colon type="password" label="确认密码" placeholder="请填写确认密码" :rules="[{ validator, message: form.msg_Repass}]"/>
      <div class="btnss">
        <van-button block round type="info" native-type="button" @click="onSubmits">确认修改</van-button>
      </div>
    </van-form>
    <div class="loading" v-show="loadingShow">
      <van-loading type="circular" vertical>{{ loadingValue }}</van-loading>
    </div>
  </div>
</template>

<script>
// , ForgetCodeCheck
import { ForgetCode, ForgetChangePassword } from '@/api/login.js'
export default {
  components: {},
  props: {},
  data () {
    return {
      form: {
        username: '',
        userCode: '',
        NewPassword1: '',
        NewPassword2: ''
      },
      // 发送验证码控制
      formTime: false,
      // 是否加载
      loadingShow: false,
      // 加载文字
      loadingValue: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 校验规则
    validator () {
      if (this.form.NewPassword1 !== this.form.NewPassword2) {
        this.form.msg_Repass = '请填写正确的确认密码'
        return false
      }
      return true
    },
    validators (val) {
      const pattern = /^(?=.*\d)(?=.*[a-z])[a-zA-Z0-9]{8,20}$/
      return pattern.test(val)
    },
    // 返回登录页面
    // Back () { this.$router.push('/login') },
    // 重新可点击按钮
    changeDownCount () {
      this.$refs.countDown.reset()
      this.formTime = false // 关闭倒计时状态
    },
    // 发送验证码 按钮
    getVertify () {
      // 重置发送验证码时间
      this.$refs.formRef.validate('username').then(async _ => {
        this.$refs.countDown.reset()
        const { data: res } = await ForgetCode({ account: this.form.username })
        if (res.code === 0 && res.msg === '操作成功') {
          this.formTime = true // 关闭倒计时状态
          return this.$toast('验证码发送成功 请注意查收')
        }
        if (res.code === 1 && res.msg.indexOf('账号不存在, 请重新输入') !== -1) return this.$toast('账号不存在, 请重新输入')
        if (res.msg.indexOf('验证码已发送, 请勿重复点击') !== -1) return this.$toast('验证码已发送, 请勿重复点击')
        this.$toast.fail('验证码发送失败')
      }).catch(_ => {
        this.$toast.fail('请输入预留手机号')
      })
    },
    // 校验验证码
    onSubmits () {
      this.$refs.formRef.validate('username').then(async _ => {
        this.$refs.formRef.validate('userCode').then(async _ => {
          this.$refs.passwoarRef.validate('NewPassword1').then(async _ => {
            this.$refs.passwoarRef.validate('NewPassword2').then(async _ => {
              this.loadingShow = true
              this.loadingValue = '修改密码中...'
              const { data: res } = await ForgetChangePassword({ account: this.form.username, code: this.form.userCode, newPassword: this.form.NewPassword1 })
              this.loadingShow = false
              if (res.code === 1 && res.msg.indexOf('验证码已失效, 请重新点击发送') !== -1) return this.$toast('验证码已失效, 请重新点击发送')
              if (res.code === 1 && res.msg.indexOf('验证码格式错误') !== -1) return this.$toast('验证码格式错误')
              if (res.code === 1 && res.msg.indexOf('账号不存在, 请重新输入') !== -1) return this.$toast('账号不存在, 请重新输入')
              if (res.code !== 0 && res.msg !== '操作成功') return this.$toast.fail('修改密码失败')
              this.loadingShow = false
              this.$toast('修改密码成功')
              this.$router.push('/login')
            }).catch(_ => {
              this.$toast.fail('请再次确认新密码')
            })
          }).catch(_ => {
            this.$toast.fail('请填写新的登录密码')
          })
        }).catch(_ => {
          this.$toast.fail('请输入验证码')
        })
      }).catch(_ => {
        this.$toast.fail('请输入预留手机号')
      })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  .box {
    width: 100%;
    height: 100%;
  }
  /deep/.van-nav-bar .van-icon {
    color: #000;
  }
  .tap, .ts {
    .van-cell__title {
      flex: 0;
    }
    .van-cell__value {
      text-align: left;
      color: rgb(105, 105, 105);
    }
  }
  .loading {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.658);
    position: absolute;
    top: 0;
    z-index:1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/.van-cell__title {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  /deep/.van-notice-bar__content {
    .phons {
      display: flex;
      h3 {
        margin: 0 5px;
        font-weight: normal;
      }
    }
  }
  .btnss {
    width: 90%;
    margin: 32px auto 0;
  }
</style>
